import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import DashboardTenantMessages from '../components/DashboardTenantMessages';
import DashboardInventoryUploads from '../components/DashboardInventoryUploads';
import { brandColors } from '../styles/brandColors';

const tileWrapperSx = {
  flex: 1,
  width: '100%',
  minHeight: { xs: 380, md: 520 },
  maxHeight: { xs: 480, md: 'calc(100vh - 280px)' },
  display: 'flex',
};

const Dashboard: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 1320, mx: 'auto' }}>
      <Paper
        elevation={0}
        sx={{
          mb: 3,
          p: { xs: 2.5, md: 3.5 },
          borderRadius: 3,
          overflow: 'hidden',
          position: 'relative',
          background: `linear-gradient(135deg, ${brandColors.navyDark} 0%, ${brandColors.navy} 42%, #1a4a9e 100%)`,
          color: '#fff',
          boxShadow: '0 14px 40px rgba(0, 21, 69, 0.22)',
          '&::before': {
            content: '""',
            position: 'absolute',
            right: -40,
            top: -40,
            width: 200,
            height: 200,
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.06)',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            right: 80,
            bottom: -60,
            width: 160,
            height: 160,
            borderRadius: '50%',
            background: 'rgba(220, 53, 69, 0.12)',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
           
          <Typography variant="h4" sx={{ fontWeight: 700, mt: 0.5, mb: 1, lineHeight: 1.2 }}>
          Store Space Claims Portal
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.86)', maxWidth: 640, lineHeight: 1.7 }}>
          Welcome to the Store Space Claims Admin Portal. Overview of your claims operations.
          </Typography>
        </Box>
      </Paper>

      <Grid container spacing={3} alignItems="stretch">
        <Grid size={{ xs: 12, lg: 6 }} sx={{ display: 'flex' }}>
          <Box sx={tileWrapperSx}>
            <DashboardTenantMessages />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }} sx={{ display: 'flex' }}>
          <Box sx={tileWrapperSx}>
            <DashboardInventoryUploads />
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 2.5,
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            px: 2,
            py: 1,
            borderRadius: 999,
            bgcolor: 'rgba(0, 30, 96, 0.06)',
            border: '1px solid rgba(0, 30, 96, 0.08)',
          }}
        >
          <ForumOutlinedIcon sx={{ fontSize: 18, color: brandColors.navy }} />
          <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
            Messages — tenant replies to your outreach
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            px: 2,
            py: 1,
            borderRadius: 999,
            bgcolor: 'rgba(0, 30, 96, 0.06)',
            border: '1px solid rgba(0, 30, 96, 0.08)',
          }}
        >
          <UploadFileOutlinedIcon sx={{ fontSize: 18, color: brandColors.navy }} />
          <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
            Uploads — new inventory receipts and evidence
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
